export const globalTabsHeight = 46;
